export const getIsThankPage = () => window.location.pathname.includes("/thanks")
